import type { OverviewResponse } from "contracts/api/dashboard/responses";
import {
  SCAN_ICON_NAME,
  SCAN_SECTION_KEY,
  type ScanSectionKey,
  SIGNAL_MODULE,
} from "../../enums/scan";
import { isOpen } from "../website/issueModel";
import type { IconName } from "./scanIcons";
import { SIGNAL_DESTINATIONS, signalDestinationHref } from "./signalModules";

type NavItem = {
  key: ScanSectionKey;
  label: string;
  href: string;
  icon: IconName;
  badge?: string;
};

type NavGroup = {
  label: string;
  items: NavItem[];
};

export function scanGroups(
  websiteId: string,
  data: OverviewResponse | null,
): NavGroup[] {
  const pageCount = data ? String(data.pages.length) : undefined;
  const issueCount = data
    ? String(data.issues.filter(isOpen).length)
    : undefined;
  return [
    {
      label: "Core scan",
      items: [
        {
          key: SCAN_SECTION_KEY.SUMMARY,
          label: "Summary",
          href: `/w/${websiteId}/scan`,
          icon: SCAN_ICON_NAME.SUMMARY,
        },
        {
          key: SCAN_SECTION_KEY.PAGES,
          label: "Flows",
          href: `/w/${websiteId}/scan/pages`,
          icon: SCAN_ICON_NAME.PAGES,
          badge: pageCount,
        },
        {
          key: SCAN_SECTION_KEY.ISSUES,
          label: "Issues",
          href: `/w/${websiteId}/scan/issues`,
          icon: SCAN_ICON_NAME.ISSUES,
          badge: issueCount,
        },
        {
          key: SCAN_SECTION_KEY.SIGNALS,
          label: "Scorecard",
          href: `/w/${websiteId}/scan/signals`,
          icon: SCAN_ICON_NAME.SIGNALS,
        },
      ],
    },
    {
      label: "History and diagnostics",
      items: [
        {
          key: SCAN_SECTION_KEY.RUNS,
          label: SIGNAL_DESTINATIONS[SIGNAL_MODULE.RUNS].label,
          href: signalDestinationHref(websiteId, SIGNAL_MODULE.RUNS),
          icon: SCAN_ICON_NAME.RUNS,
        },
        {
          key: SCAN_SECTION_KEY.AI_REFERENCE,
          label: "AI Reference",
          href: `/w/${websiteId}/scan/ai-reference`,
          icon: SCAN_ICON_NAME.AI,
        },
      ],
    },
    {
      label: "Assessment context",
      items: [
        {
          key: SCAN_SECTION_KEY.BRAND_GUIDELINES,
          label: "Brand Guidelines",
          href: `/w/${websiteId}/scan/brand-guidelines`,
          icon: SCAN_ICON_NAME.BRAND,
        },
      ],
    },
  ];
}
